import React from 'react'

import { COUNTRIES_AND_STATES } from '~/config'

import AddressFormComponent from './address-form.component'

export default (props) => (
  <AddressFormComponent {...props} countriesAndStates={COUNTRIES_AND_STATES} />
)
